import { useState } from "react";
import { BsCalendar2Check } from "react-icons/bs";
import ExpandPanel from "./ExpandPanel";

export default function PendingWidget({ bookings }: any) {
  const [isVisible, setVisible] = useState<boolean>(false);
  const data = bookings.filter((item: any) => item?.is_confirmed === false);
  return (
    <div className="col-span-12 sm:col-span-3 flex items-center border px-4 py-2 bg-white hover:bg-red-50">
      <button className="flex justify-start" onClick={() => setVisible(true)}>
        <div className="flex justify-center items-center rounded-lg border h-12 w-12 bg-red-100">
          <BsCalendar2Check size={24} />
        </div>
        <div className="flex flex-col  border-l ml-2 truncate">
          <div className="pl-2 ">Pending Bookings</div>
          <div className="pl-2 text-xl text-black font-bold text-left">
            {data?.length}
          </div>
        </div>
      </button>

      <ExpandPanel
        isVisible={isVisible}
        setVisible={setVisible}
        data={data}
        title={"Pending Bookings"}
      />
    </div>
  );
}
